import { useEffect, useMemo, useState } from "react";
import { useVideoPlayerRefs } from "../VideoPlayerRefs";
import { PlaybackRateContext } from ".";

export interface PlaybackRateProps {
  children?: React.ReactNode;
  playbackRates?: number[];
}

export const PlaybackRateProvider = ({
  children,
  playbackRates,
}: PlaybackRateProps) => {
  const { video } = useVideoPlayerRefs();
  const [playbackRate, setPlaybackRate] = useState<number>(1);

  useEffect(() => {
    if (video.current !== null) {
      video.current.playbackRate = playbackRate;
    }
  }, [playbackRate, video]);

  const isEnabled = playbackRates !== undefined && playbackRates.length > 0;

  const value = useMemo(
    () => ({ playbackRates, playbackRate, setPlaybackRate, isEnabled }),
    [isEnabled, playbackRate, playbackRates]
  );

  return (
    <PlaybackRateContext.Provider value={value}>
      {children}
    </PlaybackRateContext.Provider>
  );
};
